import React, { useCallback } from 'react';
import { loadStripe } from '@stripe/stripe-js';
import { EmbeddedCheckoutProvider, EmbeddedCheckout } from '@stripe/react-stripe-js';
import { postRequest } from '../../utils/apiUtils';
import { API_ENDPOINTS, ERROR_MESSAGES } from './utils/constants';
import styles from '../../css/Store.module.css';

// Make sure to call `loadStripe` outside of a component's render to avoid
// recreating the `Stripe` object on every render.
const stripePromise = process.env.REACT_APP_STRIPE_PUBLIC_KEY
  ? loadStripe(process.env.REACT_APP_STRIPE_PUBLIC_KEY)
  : Promise.reject(new Error('Stripe public key is not defined'));

const CheckoutForm = ({ item }) => {
  const fetchClientSecret = useCallback(() => {
    console.log("CheckoutForm: Creating checkout session for item:", item?.id);

    return postRequest(API_ENDPOINTS.CREATE_CHECKOUT, {
      productId: item?.id || `${item?.title?.toLowerCase().replace(/\s+/g, '-')}`
    })
      .then((data) => data.clientSecret)
      .catch(error => {
        console.error(ERROR_MESSAGES.CHECKOUT_ERROR, error);
        throw error;
      });
  }, [item]);

  const options = { fetchClientSecret };

  return (
    <div id="checkout" className={[styles.checkoutContainer, styles.hidden].join(' ')}>
      <EmbeddedCheckoutProvider
        stripe={stripePromise}
        options={options}
      >
        <EmbeddedCheckout />
      </EmbeddedCheckoutProvider>
    </div>
  );
};

export default CheckoutForm;
